module.exports = __webpack_public_path__ + "img/presentation-ipad.65615a83.jpg";